import { Inject, Injectable } from '@angular/core';

import { VueLoadingService, VueNavigationService, WINDOW } from '@vue/vueframework';
import { Observable, of } from 'rxjs';
import { catchError, filter, switchMap, take } from 'rxjs/operators';
import { TestCenterService } from '../services/test-center.service';

@Injectable({
  providedIn: 'root'
})
export class VueIdCheckResolver {
  public constructor(
    private testCenterService: TestCenterService,
    private vueNavService: VueNavigationService,
    @Inject(WINDOW) private vueWindow: Window,
    private loadingService: VueLoadingService
  ) { }

  public resolve(): Observable<boolean> {
    this.vueWindow.document.querySelector('html').classList.add('hide-menu');
    this.vueNavService.changeCurrentMenuStateClosed();

    // wait to make sure we are not loading
    // anything
    return this.loadingService.getRestState().pipe(
      filter((s) => !s),
      take(1),
      switchMap(() => this.testCenterService.checkVueIdNeeded()),
      catchError(() => {
        return of(false);
      })
    );
  }
}
